import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    DOCUMENTS_FETCH_ITEM,
    DOCUMENTS_ADD_ITEM,
    DOCUMENTS_DELETE_ITEM
} from './actions_def';
import {
    getDocumentItemSuccess,
    getDocumentItemError,
    addDocumentsItemSuccess,
    addDocumentsItemError,
    deleteDocumentItemSuccess,
    deleteDocumentItemError


} from './actions';


const apiUrl = servicePath;


const getDocumentItemRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/documents/' + payload.documentId, { crossdomain: true })
            .then(response => success(response.data));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getDocumentItem({ payload }) {
    try {
        const response = yield call(getDocumentItemRequest, payload);
        yield put(getDocumentItemSuccess(response));
    } catch (error) {
        yield put(getDocumentItemError(error));
    }
}


const addDocumentsItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (item.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        // let _sendingPayload = {
        //     Title: item.Title,
        //     DocumentType: item.DocumentType ? item.DocumentType : 1,
        //     Description: item.Description ? item.Description : ' ',
        //     DueDate: item.DueDate ? item.DueDate : new Date(),
        //     ReleaseDate: item.ReleaseDate ? item.ReleaseDate : new Date(),
        //     Status: _status,
        //     CreatorUserName: item.CreatorUserName ? item.CreatorUserName : _user.email,
        //     AssignedUserName: item.AssignedUserName ? item.AssignedUserName : _user.email,
        //     OwnerUserName: item.OwnerUserName ? item.OwnerUserName : _user.email,
        //     ProjectId: item.ProjectId ? item.ProjectId : 0,
        //     CategoryId: item.CategoryId ? item.CategoryId : 0,
        //     MilestoneId: item.MilestoneId ? item.MilestoneId : 0,
        // };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/documents/',
            item,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.status > 204) {
                        fail(response.data);
                    }
                    else if (response.status === 200 || response.status === 204) {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response)
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addDocumentsItem({ payload }) {

    try {
        const response = yield call(addDocumentsItemRequest, payload);

        if (response.status !== "fail") {
            yield put(addDocumentsItemSuccess(response));
        }
        else {
            yield put(addDocumentsItemError(response));
        }

    } catch (error) {
        yield put(addDocumentsItemError(error));
    }

}


const deleteDocumentRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/documents/' + item + '/',
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success" || response.data.status === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteDocumentItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteDocumentRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(deleteDocumentItemSuccess(response));
        }
        else {
            yield put(deleteDocumentItemError(response));
        }
    } catch (error) {
        yield put(addDocumentsItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(DOCUMENTS_FETCH_ITEM, getDocumentItem);
}

export function* watchAddItem() {
    yield takeEvery(DOCUMENTS_ADD_ITEM, addDocumentsItem);
}
export function* watchDeleteItem() {
    yield takeEvery(DOCUMENTS_DELETE_ITEM, deleteDocumentItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
